import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Hotkey } from 'ui-components/components/hotkey';

export const messages = defineMessages({
  name: {
    description: 'general hotkeys list hotkeys',
    defaultMessage: 'List hotkeys (keyboard shortcuts)',
    id: 'OyRE/K',
  },
});

export const hotkey = ['?'];
export const barcodeContent = '+V58S84KQ59WY=';

const ListHotkeysHotkey = ({ children, handler }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: hotkey,
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, handler],
  );

  return <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>;
};

ListHotkeysHotkey.propTypes = {
  children: PropTypes.node.isRequired,
  handler: PropTypes.func.isRequired,
};

export default ListHotkeysHotkey;
